const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
	api: 'local',
	url: function() {
		return `/app/api/products/bundle/${this.get('productUniqueId')}?bundlePrice=${this.get('originalProductPrice')}`;
	}
});
